import '.ds{font-size:1.125rem;}.ssr-plugin'
import '.fg{line-height:1.75rem;}.ssr-plugin'
import '.g3{text-decoration:none;}.ssr-plugin'
import '.gn{color:var(--brand-primary);}.ssr-plugin'
import { pages } from '@app/util/links'
import { useTranslations } from '@i18n/useLanguage'
import { styled } from 'inlines'

export const TermsAndConditions = () => {
  const translations = useTranslations().app.auth
  return (
    <p className="ds fg"
    >
      {translations.privacySubtitle}{' '}
      <a className="g3 gn"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.privacyStatementLink}
      </a>{' '}
      {translations.privacySubtitleAnd}{' '}
      <a className="g3 gn"
        href={pages.legal}
        target="_blank"
        rel="noopener noreferrer"
      >
        {translations.termsAndConditionsLink}
      </a>
    </p>
  )
}
